import { useContext } from 'react'

import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'

import MapContext from '../context/MapContext'

import Menu from '../basic-components/Menu'

export default function MenuPage({ menuItems, onChange }) {
  const { currentLocation, moveTo } = useContext(MapContext);

  const itemClickHandler = (e) => {
    const choice = e.target.innerText.trim();
    // using first one found
    const chosenItem = menuItems.filter(item => item.text === choice)[0];
    //console.log(chosenItem);
    switch (chosenItem.text) {
      case 'Video Tutorial':
        window.location.href = 'https://youtu.be/B7aNRTi4jUA';
        break;
      case 'Search for Current Location':
        // TODO: center map on current location if available
        if (currentLocation) {
          //console.log(currentLocation);
          const point = [ currentLocation.x, currentLocation.y ]
          moveTo(point);
        } else {
          // TODO: replace alert with modal?
          alert('no current location')
        }
        onChange(chosenItem);
        break;
      default:
        onChange(chosenItem);
    }
  }

  return (
    <Container>
      <Header style={{justifyContent: "center"}}>
        <HeaderTitle><strong>MapClick Mobile</strong></HeaderTitle>
      </Header>
      <Content>
      <Menu
        items={menuItems}
        onItemClick={itemClickHandler}
      />
      </Content>
    </Container>
  );
}
